import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { IGiro } from './interfaces/giro.interface';
import { GiroService } from './services/giro.service';
import { MatDialog } from '@angular/material/dialog';
import { AbcEmpresasCustomizablesComponent } from '@p-parametria/mantenimiento/abc-empresas/components/abc-empresas-customizables/abc-empresas-customizables.component';

@Component({
  selector: 'app-giro-form',
  templateUrl: './giro-form.component.html',
  providers: [MessageService]
})
export class GiroFormComponent implements OnInit, OnChanges {
  @Input() model: IGiro | null = null;
  @Output() onSave = new EventEmitter<{ success: boolean; message: string }>();
  form!: FormGroup;
  loading: boolean = false;

  constructor(
    private fb: FormBuilder,
    private messageService: MessageService,
    private giroService: GiroService,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model']) {
      if (changes['model'].currentValue) {
        this.loadGiro();
      } else {
        this.initForm();
      }
    }
  }

  initForm(): void {
    this.form = this.fb.group({
      clave_giro: [{ value: '', disabled: !!this.model }, [Validators.required]],
      tipo_dedicacion: ['', [Validators.required]],
      descripcion: ['', [Validators.required]]
    });
  }

  loadGiro(): void {
    if (this.model?.clave_giro) {
      this.loading = true;
      this.giroService.getGiroDetail(this.model.clave_giro).subscribe({
        next: (response) => {
          if (response.success && response.data.length > 0) {
            const giro = response.data[0];
            this.form.patchValue({
              clave_giro: giro.clave_giro,
              tipo_dedicacion: giro.tipo_dedicacion,
              descripcion: giro.descripcion
            });
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'No se pudo cargar el giro'
            });
          }
          this.loading = false;
        },
        error: (error) => {
          console.error('Error al cargar giro:', error);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al cargar el giro'
          });
          this.loading = false;
        }
      });
    }
  }

  create(): void {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      return;
    }

    this.loading = true;
    const formData = this.form.value;
    
    this.giroService.saveGiro(formData).subscribe({
      next: (response) => {
        if (response.success) {
          this.onSave.emit({ success: true, message: 'Giro creado exitosamente' });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo crear el giro'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al crear giro:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al crear el giro'
        });
        this.loading = false;
      }
    });
  }

  update(): void {
    if (this.form.invalid) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Por favor complete todos los campos requeridos'
      });
      return;
    }

    this.loading = true;
    const formData = this.form.value;
    
    this.giroService.updateGiro(formData).subscribe({
      next: (response) => {
        if (response.success) {
          this.onSave.emit({ success: true, message: 'Giro actualizado exitosamente' });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'No se pudo actualizar el giro'
          });
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al actualizar giro:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Error al actualizar el giro'
        });
        this.loading = false;
      }
    });
  }

  openCustomizables(): void {
    this.dialog.open(AbcEmpresasCustomizablesComponent, {
      width: '1000px',
      height: '1000px',
      disableClose: true,
      panelClass: ['custom-dialog-zindex'],
      hasBackdrop: true,
      autoFocus: false,
      data: {
        sTabla: 'giros',
        sClave: `${this.form.get('clave_giro')?.value}`,
        sNombre: this.form.get('descripcion')?.value,
        sTipo: 'Opcion'
      }
    });
  }
} 